import { Button, Icon } from '@polichat/flamboyant';
import { useSelector } from 'react-redux';
import { useOverdueCustomer } from 'src/contexts/OverdueCustomerContext';
import { openVoxPhone } from 'src/lib/openVoxPhone';

interface VoxProps {
  contact: any;
  user: any;
}

export function Vox(props: VoxProps) {
  const { isSuspended } = useOverdueCustomer();

  const customer_id = useSelector(
    (state: any) => state.general?.current_customer_id
  );
  const user_id = useSelector((state: any) => state.general?.user.id);

  function handleClickVox() {
    openVoxPhone({
      contactID: props?.contact?.id,
      customerID: customer_id,
      userID: user_id,
      contactName: props?.contact?.name,
      contactPicture: props?.contact?.picture,
    });
  }
  return (
    <Button
      disabled={isSuspended}
      onClick={handleClickVox}
      className="voxButton"
      fullWidth
      size="sm"
      style={{
        height: '40px',
        width: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon icon="poli-icon pi-phone-fill" size={25} />
    </Button>
  );
}
